import { LegalPageLayout } from './LegalPageLayout';

export function PolicyRecensioniPage() {
  return (
    <LegalPageLayout title="Policy Recensioni e Moderazione">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <p>
                      Società: Klaro7 S.r.l.s. Applicazione: Utenti e Operatori registrati sulla piattaforma Klaro7.it
                    </p>
                    <p>
                      La presente Policy disciplina la gestione delle recensioni e la moderazione dei contenuti
                      generati dagli utenti (User Generated Content) sulla piattaforma Klaro7. L&apos;obiettivo è
                      assicurare trasparenza, attendibilità e rispetto reciproco tra Utenti, Operatori e la piattaforma
                      stessa.
                    </p>
      
                    <h2>1. Regola di base: autenticità e tempistica</h2>
                    <ol>
                      <li>
                        <strong>Verifica:</strong> Solo gli Utenti che hanno effettivamente usufruito di un servizio (consulto
                        completato e pagato) tramite Klaro7 possono lasciare una recensione.
                      </li>
                      <li>
                        <strong>Tempistica:</strong> Le recensioni devono essere pubblicate entro 30 giorni dalla
                        conclusione della prestazione.
                      </li>
                    </ol>
      
                    <h2>2. Contenuti ammessi e vietati</h2>
                    <h3>Contenuti Ammessi</h3>
                    <p>Sono ammesse recensioni che:</p>
                    <ul>
                      <li>Descrivono esperienze personali in modo veritiero e specifico.</li>
                      <li>Contengono giudizi civili, non offensivi e coerenti con la prestazione ricevuta.</li>
                      <li>Sono pubblicate in conformità con la presente Policy.</li>
                    </ul>
                    <h3>Contenuti Vietati (Causano la Rimozione Immediata)</h3>
                    <p>Sono vietate recensioni che contengono:</p>
                    <ul>
                      <li>
                        <strong>Linguaggio Ostile:</strong> Volgare, discriminatorio, minacce, insulti o diffamazione (contro
                        Utenti, Operatori o la Società).
                      </li>
                      <li>
                        <strong>Accuse Indimostrabili:</strong> Accuse di natura penale, morale o truffaldina non verificabili
                        e non comprovate in sede legale.
                      </li>
                      <li>
                        <strong>Dati Privati:</strong> Dati personali, numeri di telefono, e-mail, link esterni, o riferimenti per la
                        non-sollecitazione.
                      </li>
                      <li>
                        <strong>Contenuti Fuori Tema:</strong> Pubblicità, autopromozione o contenuti non riferibili
                        all&apos;esperienza diretta del consulto.
                      </li>
                    </ul>
      
                    <h2>3. Diritto di replica dell&apos;Operatore</h2>
                    <p>
                      L&apos;Operatore ha il diritto di difendere la propria reputazione rispondendo alle recensioni, nel
                      rispetto della privacy dell&apos;Utente.
                    </p>
                    <ol>
                      <li>
                        <strong>Tempistica:</strong> L&apos;Operatore ha il diritto di replicare in modo civile alle recensioni,
                        negative o positive, entro un termine di 7 giorni dalla pubblicazione.
                      </li>
                      <li>
                        <strong>Riservatezza Assoluta:</strong> La replica deve essere professionale e non può in alcun
                        caso rivelare dettagli specifici o contenuti confidenziali del consulto (es.
                        informazioni sul problema personale dell&apos;Utente).
                      </li>
                      <li>
                        <strong>Moderazione:</strong> Klaro7 si riserva il diritto di moderare o rimuovere la replica
                        dell&apos;Operatore se viola le presenti regole.
                      </li>
                    </ol>
      
                    <h2>4. Moderazione e criteri di rimozione</h2>
                    <ol>
                      <li>
                        <strong>Moderazione:</strong> Tutte le recensioni possono essere soggette a moderazione
                        preventiva o successiva, anche su segnalazione motivata di un Operatore o di un
                        Utente.
                      </li>
                      <li>
                        <strong>Discrezionalità:</strong> La decisione di rimozione o oscuramento di una recensione che
                        viola la presente Policy è a insindacabile discrezione di Klaro7 S.r.l.s.
                      </li>
                      <li>
                        <strong>Recensioni non Autentiche:</strong> Klaro7 può sospendere o eliminare recensioni ritenute
                        non autentiche, ad esempio: recensioni multiple dallo stesso indirizzo IP, account
                        multipli, o recensioni pubblicate da Operatori o persone a loro collegate.
                      </li>
                    </ol>
      
                    <h2>5. Valutazione e durata</h2>
                    <ol>
                      <li>
                        <strong>Punteggio:</strong> Ogni Operatore mostra un punteggio medio aggiornato, calcolato solo
                        sulle recensioni verificate.
                      </li>
                      <li>
                        <strong>Conservazione:</strong> Le recensioni sono conservate per 24 mesi dalla pubblicazione,
                        salvo richiesta di cancellazione da parte dell&apos;Utente o obblighi legali differenti.
                      </li>
                      <li>
                        <strong>Privacy:</strong> I dati di recensione sono trattati nel rispetto del GDPR e dell&apos;Informativa
                        Privacy di Klaro7.
                      </li>
                    </ol>
      
                    <h2>6. Violazioni, conseguenze e tutela legale</h2>
                    <p>
                      La violazione della presente Policy da parte dell&apos;Utente comporta l&apos;adozione delle seguenti
                      misure:
                    </p>
                    <ol>
                      <li>
                        <strong>Prima Violazione:</strong> Avviso scritto e rimozione del contenuto.
                      </li>
                      <li>
                        <strong>Seconda Violazione:</strong> Sospensione temporanea dell&apos;Account Utente.
                      </li>
                      <li>
                        <strong>Casi Gravi o Reiterati:</strong> Rimozione definitiva dell&apos;Account Utente, blocco dell&apos;accesso
                        alla Piattaforma e cancellazione di ogni credito residuo.
                      </li>
                      <li>
                        <strong>Azioni Legali per Danno:</strong> La pubblicazione di recensioni false, manipolate,
                        diffamatorie o che contengano accuse calunniose nei confronti di un Operatore o
                        della Società espone l&apos;Utente non solo alla rimozione definitiva dalla piattaforma, ma
                        anche a azioni legali per risarcimento danni a tutela della reputazione di Klaro7
                        S.r.l.s. e dei suoi collaboratori.
                      </li>
                    </ol>
      
                    <h2>7. Disposizioni finali</h2>
                    <ul>
                      <li>
                        <strong>Modifiche:</strong> Klaro7 può aggiornare la presente Policy in qualsiasi momento, con
                        preavviso di 15 giorni tramite pubblicazione sul sito o area riservata. L&apos;uso
                        continuativo della piattaforma dopo tale termine implica l&apos;accettazione delle
                        modifiche.
                      </li>
                      <li>
                        <strong>Legge e Foro:</strong> La presente Policy è regolata dalla legge italiana. In caso di
                        controversie è competente il Foro di Torino, salvo diverse disposizioni inderogabili a
                        tutela del consumatore.
                      </li>
                    </ul>
    </LegalPageLayout>
  );
}
